export default function enabledisableReactConfigurationReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'ENABLE_OR_DISABLE_REACT_CONFIGURATION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'ENABLE_OR_DISABLE_REACT_CONFIGURATION_ERROR':
            return {...state, ...{error: action.error}};

        case 'ENABLE_OR_DISABLE_REACT_CONFIGURATION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}